"use client";

import { NuqsAdapter } from "nuqs/adapters/next/app";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import Navbar from "@/shared/components/Navbar/Navbar";
import Footer from "@/shared/components/Footer";
import OutboundLinkTracker from "@/shared/components/Analytics/OutboundLinkTracker";
import UtmAppender from "@/shared/components/Analytics/UtmAppender";
import LandingAnalyticsTracker from "@/shared/components/Analytics/LandingAnalyticsTracker";

export default function Providers(props: Readonly<{ children: React.ReactNode }>) {
  const [queryClient] = useState(function createQueryClient() {
    return new QueryClient({
      defaultOptions: {
        queries: { refetchInterval: 2 * 60e3, staleTime: 2 * 60e3, gcTime: 3 * 60e3 },
      },
    });
  });

  return (
    <NuqsAdapter>
      <QueryClientProvider client={queryClient}>
        <div className="relative">
          <OutboundLinkTracker />
          <UtmAppender />
          <LandingAnalyticsTracker />
          <Navbar />
          {props.children}
          <Footer />
        </div>
      </QueryClientProvider>
    </NuqsAdapter>
  );
}
